
interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
      <div className="px-8 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center cursor-pointer"
          >
            <img 
              src="https://public.readdy.ai/ai/img_res/2fb37805-8251-4182-9787-cb5a44bb30ab.png" 
              alt="Caribbean Fashion Fest" 
              className="h-12 w-auto"
            />
          </button>
          
          <div className="hidden lg:flex items-center gap-10">
            <button onClick={() => scrollToSection('tickets')} className="text-sm tracking-wide hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">Tickets</button>
            <button onClick={() => scrollToSection('schedule')} className="text-sm tracking-wide hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">Schedule</button>
            <button onClick={() => scrollToSection('designers')} className="text-sm tracking-wide hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">Designers</button>
            <button onClick={() => scrollToSection('experience')} className="text-sm tracking-wide hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">Experience</button>
            <button onClick={() => scrollToSection('venue')} className="text-sm tracking-wide hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">Venue</button>
            <button onClick={() => scrollToSection('contact')} className="text-sm tracking-wide hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">Contact</button>
          </div>

          <button 
            onClick={() => scrollToSection('tickets')}
            className="hidden lg:block px-8 py-3 bg-[#14B8A6] text-white text-sm tracking-wide hover:bg-[#0F9B8E] transition-colors cursor-pointer whitespace-nowrap"
          >
            VIP Access
          </button>
        </div>
      </div>
    </nav>
  );
}
